export default "__VITE_ASSET__DED6_esV__"